import { client as axios } from "./axiosClient";
import { Constants } from "@socialcoach/services";
import * as DTO from "../interfaces";
import { CancelToken } from "axios";
import { scCatchServiceException } from "../annotations";

const CALENDAR_EVENT_SERVICE = `${Constants.API_URL}/calendar_events`;

export class CalendarEventServices {
  @scCatchServiceException()
  static async getCalendarEvents(
    dateTime: Date,
    timePeriod: DTO.TimePeriod,
    coachId?: number,
    playerIds?: number[],
    cancelToken?: CancelToken,
    page: number = 0,
    size: number = 2000
  ): Promise<DTO.Page<DTO.CalendarEvent>> {
    const queryParams = new URLSearchParams();
    queryParams.append("dateTime", dateTime.toISOString());
    queryParams.append("timePeriod", timePeriod);
    playerIds?.forEach(playerId => queryParams.append("playerIds", playerId.toString()));
    if (coachId) queryParams.append("coachId", coachId.toString());
    queryParams.append("page", page.toString());
    queryParams.append("size", size.toString());

    const url = `${CALENDAR_EVENT_SERVICE}/?${queryParams.toString()}`;
    const { data } = await axios.get<DTO.Page<DTO.CalendarEvent>>(url, { withCredentials: true, cancelToken });
    return data;
  }

  @scCatchServiceException()
  static async getCalendarEventDetails(eventId: string): Promise<DTO.CalendarEventDetails> {
    const url = `${CALENDAR_EVENT_SERVICE}/${eventId}`;
    const { data } = await axios.get<DTO.CalendarEventDetails>(url, { withCredentials: true });
    return data;
  }
}
